import * as React from 'react';
import * as att from "./style.module.scss";

export const Attention = () => {
  return (
    <section className={att.attention}>
      <div className="container">
        <div className={att.wrapper}>
          <img
            className={att.image}  
            src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/iphone-hand.png"
            alt=""
          />
          <div className={att.content}>
            <h2 className={att.title}>Обратите внимание:</h2>
            <ul className={att.list}>
              <li className={att.item}><strong>Присутствие родителей в&nbsp;чате
                не&nbsp;предусмотрено,</strong> но&nbsp;вы&nbsp;всегда можете запросить обратную связь
                об&nbsp;успеваемости ребёнка и&nbsp;его прогрессе.
              </li>
              <li className={att.item}>В&nbsp;ежедневном расписании ребёнка должно быть <strong>минимум
                30&nbsp;минут</strong> на&nbsp;занятия с&nbsp;онлайн-курсом.
              </li>
              <li className={att.item}>Строго обязательно соблюдение <strong>дедлайна 15:00
                (по&nbsp;Мск)</strong> для сдачи заданий.
              </li>
              <li className={att.item}>В&nbsp;случае отставания ребёнок будет переведён в&nbsp;другую
                группу. Эта <strong>возможность предоставляется дважды,</strong> после чего ученик переходит
                на&nbsp;самостоятельное прохождение курса.
              </li>
              <li className={att.item}>За&nbsp;14&nbsp;недель ребёнок в&nbsp;общей группе осваивает все
                технологии на&nbsp;материалах разных предметов. После чего проходит тестирование, выбирает один
                предмет и&nbsp;переходит в&nbsp;<strong>бесплатный специализированный чат.</strong> На&nbsp;этом
                этапе ребёнок уже самостоятельно закрепляет полученные навыки на&nbsp;материалах отдельно взятого
                предмета, по&nbsp;мере необходимости консультируясь с&nbsp;преподавателем-предметником. Также
                в&nbsp;чате будут публиковаться дополнительные материалы.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
